const mEditionAssetContentsModalCreateVersion = {
  mEditionAssetContentsModalCreateVersion: {
    alerts: {
      createContenido: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'La versión fue creada exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'CREAR',

    inputs: {
      nombre: {
        label: 'Escribe aquí un nombre' // ,
        // message: '* De 5 a 255 caracteres'
      }
    },

    title: 'Nueva Versión de Contenidos',

    validation: {
      version: {
        nombre: {
          // maxLength: 'La longitud máxima permitida es de 255 caracteres.',
          // minLength: 'La longitud mínima permitida es de 5 caracteres.',
          required: 'Nombre de versión es requerido.'
        }
      }
    }
  }
}

export default mEditionAssetContentsModalCreateVersion
